/* 🤖 this file was generated by svg-to-ts */
export const matIconShuffle: {
  name: 'shuffle';
  data: string;
} = {
  name: 'shuffle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.59 9.17 5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"/></svg>`
};
